import PlanPickerOption from './Hosting/PlanPickerOption';
import { useState } from 'react';
import Button from '@mui/material/Button';
import Link from 'next/link';
import { AI_CREDITS_CHECKOUT_LINK } from '../../helpers/graphql/aiCredits';
import graphQLClient from 'helpers/graphQLClient';
import { useQuery } from '@apollo/client';
import { GET_HOSTING_PLAN } from '../../helpers/graphql/hosting';
import VerifyEmail from './Hosting/VerifyEmail';
import Typography from '@mui/material/Typography';

const plans = [
  {
    title: '1 Million',
    pricing: { oneTime: 10 },
    features: '~100 posts / 2,000 maps • ~0.10$ per post / ~0.005 per map',
  },
  {
    title: '5 Million',
    pricing: { oneTime: 30 },
    features: '~500 posts / 10,000 maps • ~0.06$ per post / ~0.003$ per map',
    isHighlighted: true,
  },
  {
    title: '20 Million',
    pricing: { oneTime: 100 },
    features: '~2,000 posts / 40,000 maps • ~0.05$ per post / ~0.0025 per map',
  },
];

export default function AiBloggerCreditsPurchase({
  isOutOfCredits,
  onLinkClick,
  minCredits,
}) {
  const [selected, setSelected] = useState('5 Million');
  const [checkoutClicked, setCheckoutClicked] = useState(false);
  const [emailVerificationComplete, setEmailVerificationComplete] = useState(
    false,
  );

  const getCheckoutLink = () => {
    if (onLinkClick) onLinkClick();
    setCheckoutClicked(true);
    graphQLClient(AI_CREDITS_CHECKOUT_LINK, {
      plan: selected,
    })
      .then(res => {
        //   Redirect to checkout link
        if (res && res.aiCreditsCheckoutLink) {
          const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
          if (isIOS || onLinkClick) {
            window.open(res.aiCreditsCheckoutLink, '_blank');
          } else {
            window.location.href = res.aiCreditsCheckoutLink;
          }
        }
        // else: TODO: Show error snackbar
      })
      .catch(err => {
        console.log(err);
        // TODO: Show error snackbar
      });
  };

  const { data } = useQuery(GET_HOSTING_PLAN, {
    ssr: false,
    fetchPolicy: 'no-cache',
  });

  const introSentence = isOutOfCredits
    ? `Attention all AI Blogger enthusiasts! You need to have at least ${
        minCredits || '10,000'
      } AI credits to join the party. `
    : `Don't let a lack of credits hold you back from using the AI Blogger. `;

  if (!data || !data.getHostingPlan) return <></>;
  if (!data.getHostingPlan.hasVerifiedEmail && !emailVerificationComplete)
    return (
      <>
        <Typography variant="h6" className="pb-2">
          Add your email
        </Typography>
        <div className="postcontent pb-2">
          {introSentence}Before you can top up your credits, you need to verify
          your email address.
        </div>
        <VerifyEmail
          setEmailVerificationComplete={setEmailVerificationComplete}
        />
      </>
    );

  return (
    <>
      <div className="postcontent">
        {introSentence}You can purchase AI credits as a one-time purchase below.
        Or,{' '}
        <Link href="/dashboard/hosting">
          become a TravelFeed Hosting subscriber
        </Link>{' '}
        to receive up to 2 Million AI credits every month - on the house!
      </div>
      <div className="tw-mt-6 tw-space-y-8 xl:tw-mt-12">
        {plans.map(plan => (
          <PlanPickerOption
            key={plan.title}
            plan={plan}
            setSelected={setSelected}
            selected={selected}
          />
        ))}
      </div>
      <div className="tw-flex tw-justify-center tw-mt-8">
        <Button
          color="primary"
          variant="contained"
          onClick={getCheckoutLink}
          disabled={checkoutClicked}
          size="large"
        >
          Buy Credits
        </Button>
      </div>
      <div className="tw-text-gray-600 dark:tw-text-gray-400 tw-text-xs text-center tw-mt-4">
        One-time payment
      </div>
      <div className="tw-text-gray-600 dark:tw-text-gray-400 tw-text-xs text-center tw-mt-4">
        Credit usage varies depending on length of notes and the generated post.
        Pricing for regular mode. High quality mode costs 20x more credits.
      </div>
    </>
  );
}
